// React Basic and Bootstrap
import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

//Import Components
import SectionTitleLeft from "../../../components/Shared/SectionTitleLeft";

//import images
import hosting1 from "../../../assets/images/dostavka.png";
import hosting2 from "../../../assets/images/market.jpg";
import dealHend from "../../../assets/images/contact.png";

class HowItWorks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      features1: [
        { title: "CRM для обработки заказов: AmoCRM, Bitrix, RetailCRM и др" },
        { title: "Сервисы для работы общепита: R-keeper, iiko" },
        { title: "Доставка товаров: ЯндексДоставка, СДЭК, Почта России и др" },
        { title: "Складские сервисы: Мой склад, 1С-склад" },
        { title: "Привязка к расчетному счету: Сбербанк, Тинькофф, Точка и др" },
        { title: "Учет финансов: 1С-бухгалтерия и др" },
        { title: "ERP-системы" },
      ],
      features2: [
        { title: "Telegram: Просмотр товаров и общение с клиентами" },
        { title: "WhatsApp: Отвечайте на вопросы клиентов и получайте заказы" },
        { title: "VK: Список товаров в Вашей группе прямо с сайта" },
      ],
      features3: [
        // { title: "Общий демо-сайт" },
        // { title: "Общая админка сайта" },
        { title: "Логин: demo@kit-app.ru" },
        { title: "Пароль: demodemo" },
      ],
      features4: [
        { title: "Создание сложного товара для комбо" },
        { title: "Клиент сможет выбрать добавить товары предложенные на выбор" },
        { title: "В карточке можно указать разные свойства, атрибуты, характеристики" },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        <section className="section bg-light">
          <Container>
            <Row className="align-items-center">
              <Col lg={5} md={6}>
                <img src={hosting1} className="img-fluid" alt="" />
              </Col>

              <Col lg={7} md={6} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                <div className="section-title ms-lg-5">
                  <SectionTitleLeft
                    title="Интеграция с различными сервисами"
                    desc="Интеграция с различными сервисами, необходимые каждому бизнесу"
                    features={this.state.features1}
                    class=""
                  />
                  {/* <Link to="#" className="btn btn-primary mt-3">
                    Перейти <i className="uil uil-angle-right-b"></i>
                  </Link> */}
                </div>
              </Col>
            </Row>
          </Container>


          <Container className="mt-100 mt-60">
            <Row className="align-items-center">
              <Col
                lg={6}
                md={{ size: 6, order: 1 }}
                xs={{ order: 2 }}
                className="mt-4 mt-sm-0 pt-2 pt-sm-0"
              >
                <div className="section-title">
                  <SectionTitleLeft
                    title="Тесная связь с социальными сетями"
                    desc="Тесная связь с социальными сетями, для общения с клиентами и рекламы"
                    features={this.state.features2}
                    class=""
                  />
                  {/* <Link to="#" className="btn btn-primary mt-3">
                    Перейти <i className="uil uil-angle-right-b"></i>
                  </Link> */}
                </div>
              </Col>

              <Col lg={6} md={{ size: 6, order: 2 }} xs={{ order: 1 }}>
                <img src={dealHend} className="img-fluid" alt="" />
              </Col>
            </Row>
          </Container>

{/* <Container className="mt-100 mt-60">
  <Row className="align-items-center">
    <Col
      lg={6}
      md={{ size: 6, order: 1 }}
      xs={{ order: 2 }}
      className="mt-4 mt-sm-0 pt-2 pt-sm-0"
    >
      <div className="section-title">
        <SectionTitleLeft
          title="Товар можно настроить по-разному"
          desc=""
          features={this.state.features4}
          class=""
        />
      </div>
    </Col>

    <Col lg={6} md={{ size: 6, order: 2 }} xs={{ order: 1 }}>
      <img src={dealHend} className="img-fluid" alt="" />
    </Col>
  </Row>
</Container>

<Container className="mt-100 mt-60">
  <Row className="align-items-center">
    <Col
      lg={6}
      md={{ size: 6, order: 1 }}
      xs={{ order: 2 }}
      className="mt-4 mt-sm-0 pt-2 pt-sm-0"
    >
      <div className="section-title">
        <SectionTitleLeft
          title="Тесная связь с социальными сетями"
          desc="Тесная связь с социальными сетями, для общения с клиентами и рекламы"
          features={this.state.features2}
          class=""
        />
      </div>
    </Col>

    <Col lg={6} md={{ size: 6, order: 2 }} xs={{ order: 1 }}>
      <img src={dealHend} className="img-fluid" alt="" />
    </Col>
  </Row>
</Container>

<Container className="mt-100 mt-60">
  <Row className="align-items-center">
    <Col
      lg={6}
      md={{ size: 6, order: 1 }}
      xs={{ order: 2 }}
      className="mt-4 mt-sm-0 pt-2 pt-sm-0"
    >
      <div className="section-title">
        <SectionTitleLeft
          title="Тесная связь с социальными сетями"
          desc="Тесная связь с социальными сетями, для общения с клиентами и рекламы"
          features={this.state.features2}
          class=""
        />
      </div>
    </Col>

    <Col lg={6} md={{ size: 6, order: 2 }} xs={{ order: 1 }}>
      <img src={dealHend} className="img-fluid" alt="" />
    </Col>
  </Row>
</Container> */}

          <Container className="mt-100 mt-60">
            <Row className="align-items-center">
              <Col lg={5} md={6}>
                <img src={hosting2} className="img-fluid" alt="" />
              </Col>

              <Col lg={7} md={6} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                <div className="section-title ms-lg-5">
                  <SectionTitleLeft
                    title="Бесплатный и демо доступ"
                    desc="При регистрации мы поможем настроить магазин и Вы бесплатно сможете оценить его работу"
                    features={this.state.features3}
                    class=""
                  />
                  <a target={"_blank"} href="https://demo.redmonkey.wskitapp.ru/" className="btn btn-primary mt-3">
                    Демо сайт <i className="uil uil-angle-right-b"></i>
                  </a>&nbsp;&nbsp;&nbsp;
                  <a target={"_blank"} href="https://demodark.redmonkey.wskitapp.ru/" className="btn btn-primary mt-3">
                    Темный демо сайт <i className="uil uil-angle-right-b"></i>
                  </a>&nbsp;&nbsp;&nbsp;
                  <a target={"_blank"} href="https://demo.redmonkey.wskitapp.ru/admin/" className="btn btn-primary mt-3">
                    Демо админка <i className="uil uil-angle-right-b"></i>
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* <div className="position-relative">
          <div className="shape overflow-hidden text-white">
            <svg
              viewBox="0 0 2880 250"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M720 125L2160 0H2880V250H0V125H720Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div> */}
      </React.Fragment>
    );
  }
}

export default HowItWorks;
